export default function createMessageBusClient(
    settings,
    channel,
    onMessage,
    disconnectedAt = null
) {
    const { messageBusUri } = settings;

    let isOpen = false;
    let webSocket = new WebSocket(messageBusUri);

    webSocket.addEventListener("open", function () {
        isOpen = true;
        webSocket.send(JSON.stringify({ channel, disconnectedAt }));
        disconnectedAt = null;
    });

    webSocket.addEventListener("message", (event) => {
        onMessage(JSON.parse(event.data));
    });

    webSocket.addEventListener("close", () => {
        isOpen = false;
        const interval = window.setInterval(() => {
            if (!isOpen) {
                createMessageBusClient(
                    settings,
                    channel,
                    onMessage,
                    new Date().getTime()
                );
                clearInterval(interval);
                webSocket = null;
            }
        }, 1000);
    });

    return webSocket;
}
